import { render, staticRenderFns } from "./View.vue?vue&type=template&id=294a3e0a"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('294a3e0a')) {
      api.createRecord('294a3e0a', component.options)
    } else {
      api.reload('294a3e0a', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=294a3e0a", function () {
      api.rerender('294a3e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/core/View.vue"
export default component.exports